import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the CustomDatepickerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-custom-datepicker',
  templateUrl: 'custom-datepicker.html',
})
export class CustomDatepickerPage {
  months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'
  ];
  years: any = [];
  year: any;
  month: any;
  day: any;
  days = [];
  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    for (let i = 1920; i <= 2050; i++) {
      this.years.push(i);
    }

    this.setToday();
  }

  setToday() {
    const date = new Date();
    this.day = date.getDate();
    this.month = date.getMonth() + 1;
    this.year = date.getFullYear();
    this.daysInMonth(1, this.month, this.year);
  }

  daysInMonth(start, month, year) {
    this.days = [];
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    let nofday = new Date(year, month, 0).getDate();
    let dayobj = {};
    for (let i = start; i <= nofday; i++) {
      const d = new Date(year + '-' + month + '-' + i);
      const dayName = days[d.getDay()];
      dayobj[dayName] = i;
      if (dayName == 'saturday' || i == nofday) {
        this.days.push(dayobj);
        dayobj = {};
      }
    }
  }

  onChangeMonthYear() {
    this.daysInMonth(1, this.month, this.year);
  }

}



// WEBPACK FOOTER //
// ./src/pages/custom-datepicker/custom-datepicker.ts